import React from 'react';

export default function Faq() {
  return (
    <>
    <section className="ptb-40 bg-2">
     <div className="container">
         <h5>Riya Dubey Frequently Asked Questions</h5>
         <div class="faq">
             <details class="faq-item">
                 <summary class="faq-question">1 What assures me that Riya Dubey Gurgaon Escort Services is not a fake agency?</summary>
                 <div class="faq-answer">This is among the most prevalent issues. Riya Dubey Gurgaon Escort Services are concentrated on the quality profile and personal communication. Random redirects and unclear processes are non-existent. You talk straight, you seek clarity and nothing is done before verification thus preventing fabricated listing or false claims.</div>
             </details>
             <details class="faq-item">
                 <summary class="faq-question">2 Can we safely reserve an escort in Gurgaon hotels or in personal places?</summary>
                 <div class="faq-answer">Yes, discretion and safety is an issue. Escorts know the hotels and other secretive places in Gurgaon and the bookings are done with caution. No unnecessary disclosure of personal information is done and meetings are scheduled with ease to prevent drawing attention and embarrassment.</div>
             </details>
             <details class="faq-item">
                 <summary class="faq-question">3 What are the locations of your escort services in Gurgaon?</summary>
                 <div class="faq-answer">Escort services can be offered in large Gurgaon areas such as Cyber City, Golf Course Road, MG Road, sector 29, Sohna Road, residential areas, etc. Visits to hotels and private locations are both supported, as well as your choice.</div>
             </details>
             <details class="faq-item">
                 <summary class="faq-question">4 Is it possible to select between high-end escorts and lower-end ones?</summary>
                 <div class="faq-answer">Yes. Riya Dubey Gurgaon Escort Services has got premium and low-cost escorts. You do not have to be pressured or fooled into making any decision based on your convenience, anticipation, and finances.</div>
             </details>
             <details class="faq-item">
                 <summary class="faq-question">5 Can there be last minute or late night booking in Gurgaon?</summary>
                 <div class="faq-answer">Yes, services are available 24/7. A high number of clients make last minute bookings or during a time when they are already in bed, or after work. Confirmation is usually fast as long as basic details are exchanged in a well to do manner.</div>
             </details>
             <details class="faq-item">
                 <summary class="faq-question">6 Will my name and discussion be confidential?</summary>
                 <div class="faq-answer">Yes. There is a high level of privacy. Discussions and reservation details, as well as personal details, are not disclosed. This is particularly significant to the working professionals and married clients and it is done very tactfully.</div>
             </details>
          </div>
       </div>
    </section>
    </>
  )
}
